import type { TMessages } from '@/types/TMessages'

export const messages = {
  tagNotFound: 'По данному тегу нет материалов, либо данного тега не существует',
  reactHelmetTitle: 'Публикации по тегу: {tagName}',
  articlesHeader: 'Статьи',
} satisfies TMessages
